var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fill-height"},[_c('action-tile',{attrs:{"image":"no-checkin.svg","max-image-width":"400px","title":"dayplanning.no-checkins","subtitle":"dayplanning.checkin-cta","border":true,"disabled":_vm.disabled},on:{"click":_vm.emitClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }